module.exports = "/images/esperanto.svg?1155d34de5e504b2957e6a918a892204";